const partOf = (components, type, key) => {
  const match = (components || []).find((component) => component?.types?.[0] === type);
  return match ? match[key] : undefined;
};

export const marketFromGeocode = (result) => {
  const components = result?.address_components || [];
  const location = result?.geometry?.location || {};
  const city = partOf(components, "locality", "long_name");
  const state = partOf(components, "administrative_area_level_1", "short_name");
  const county = partOf(components, "administrative_area_level_2", "short_name");
  const formattedAddress = city !== undefined ? `${city}, ${state}` : result?.formatted_address || "";
  return {
    city,
    state,
    county,
    formattedAddress,
    locationObject: {
      latitude: location.lat ?? "",
      longitude: location.lng ?? "",
      city,
      state,
      formatted_address: formattedAddress,
    },
  };
};
